<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { AlignRight, ChevronDown, X } from "lucide-vue-next";
import { useThemeStore } from "@/stores/themeStore";
import logo from '../../assets/xpertlogo.png'
const themeStore = useThemeStore();

const activeDropdown = ref(null);
const activeMobileDropdown = ref(null);
const showMobileMenu = ref(false);

// Toggle mobile dropdown
const toggleMobileDropdown = (label) => {
  activeMobileDropdown.value =
    activeMobileDropdown.value === label ? null : label;
};

// Close menus on Escape
const handleEscapeKey = (e) => {
  if (e.key === "Escape") {
    showMobileMenu.value = false;
  }
};

onMounted(() => {
  document.addEventListener("keydown", handleEscapeKey);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleEscapeKey);
});
</script>

<template>
  <!-- Only render after theme is loaded -->
  <header v-if="themeStore.theme?.header" class="w-full">
     <!-- Top Bar -->
    <div class="bg-[#FDB813] hidden md:flex text-white text-sm py-2 px-4 overflow-hidden">
      <div class="flex items-center justify-center whitespace-nowrap">
        <span class="mr-8">Universities the winners if Labor assumes government</span>
        <span class="mr-8">||</span>
        <span class="mr-8">Overseas students boost population growth</span>
        <span>Admission for Ph.D. Programme</span>
      </div>
    </div>

    <!-- Navbar -->
    <div
      class="bg-white shadow-sm py-4 px-6 md:px-10 lg:px-20 flex items-center justify-between"
    >
      <!-- Logo -->
      <a href="/" class="flex items-center space-x-2">
        <img
          :src="themeStore.theme.header.logo"
          alt="Logo"
          class="h-10 w-auto"
        />
      </a>

      <!-- Desktop Menu -->
      <nav class="hidden lg:flex items-center space-x-6">
        <a
          v-for="item in themeStore.theme.header.menu"
          :key="item.label"
          :href="item.link"
          class="text-gray-700 hover:text-yellow-500 font-medium"
        >
          {{ item.label }}
        </a>
       
      </nav>

      <!-- Mobile Menu Button -->
      <div class="lg:hidden flex items-center space-x-2">
        <button
          @click="showMobileMenu = true"
          class="text-gray-700 hover:text-yellow-500 p-2"
        >
          <AlignRight class="h-6 w-6" />
        </button>
      </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <transition name="slide">
      <div
        v-if="showMobileMenu"
        class="fixed inset-0 bg-black/50 z-50 lg:hidden"
        @click.self="showMobileMenu = false"
      >
        <!-- Mobile Menu Panel -->
        <div
          class="fixed top-0 right-0 h-full w-80 max-w-[85vw] bg-white shadow-xl"
        >
          <div
            class="flex items-center justify-between p-6 border-b border-gray-200"
          >
            <img
              :src="themeStore.theme.header.logo"
              alt="Logo"
              class="h-8 w-auto"
            />
            <button
              @click="showMobileMenu = false"
              class="text-gray-500 hover:text-gray-700 p-1"
            >
              <X class="h-6 w-6" />
            </button>
          </div>

          <!-- Mobile Menu Links -->
          <nav class="flex flex-col p-4 space-y-4">
            <a
              v-for="item in themeStore.theme.header.menu"
              :key="item.label"
              :href="item.link"
              class="text-gray-700 hover:text-yellow-500 font-medium"
              @click="showMobileMenu = false"
            >
              {{ item.label }}
            </a>
           
          </nav>
        </div>
      </div>
    </transition>
  </header>
</template>
